"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.refreshStorage = exports.saveSessionUUID = exports.getSessionUUID = exports.saveUserUUID = exports.getUserUUID = void 0;
var session_uuid_1 = require("./session-uuid");
// import { isMobileVersion } from "../helpers"
var _1 = require(".");
var user_uuid_1 = require("./user-uuid");
var user_uuid_2 = require("./user-uuid");
__createBinding(exports, user_uuid_2, "getUserUUID");
__createBinding(exports, user_uuid_2, "saveUserUUID");
// 
// const DESKTOP_DOCUMENT_UUID_STORAGE_NAME = 'templateroller-session' // Per-document storage name
// const DESKTOP_MOBILE_UUID_STORAGE_NAME = 'templateroller-mobile-session'
// const storageName = () => (isMobileVersion() ? DESKTOP_MOBILE_UUID_STORAGE_NAME : DESKTOP_DOCUMENT_UUID_STORAGE_NAME)
var DOCUMENT_UUID_STORAGE_NAME = 'templateroller-session'; // Per-document storage name
var UPLOAD_UUID_STORAGE_NAME = 'templateroller-upload';
var storageName = function () {
    var pathname = window.location.pathname.match(/^\/([\w\-]+)\//);
    if (pathname && pathname[1]) {
        switch (pathname[1]) {
            case 'upload':
            case 'user-edit':
                return UPLOAD_UUID_STORAGE_NAME;
        }
    }
    return DOCUMENT_UUID_STORAGE_NAME;
};
var getSessionUUID = function (document_id) { return session_uuid_1.getDocumentUUID(storageName(), document_id); };
exports.getSessionUUID = getSessionUUID;
var saveSessionUUID = function (document_id, uuid) { return session_uuid_1.saveDocumentUUID(storageName(), document_id, uuid); };
exports.saveSessionUUID = saveSessionUUID;
var refreshStorage = function (data) {
    var userUUID = data.user_uuid;
    var sessionUUID = data.user_session_uuid;
    var documentId = data.doc_id;
    if (sessionUUID !== exports.getSessionUUID(documentId)) {
        exports.saveSessionUUID(documentId, sessionUUID);
    }
    if (userUUID !== user_uuid_1.getUserUUID()) {
        _1.saveUserUUID(userUUID);
    }
};
exports.refreshStorage = refreshStorage;
